export default "__VITE_ASSET__DgLxt__X__"